import React from "react";
import { Card } from "../../../common";
import CompanyLogo from "../../../../assets/images/companylogo.png";
import { ReactComponent as ArrowRight } from "../../../../assets/icons/arrowRight2.svg";
import { ReactComponent as VerifiedCheck } from "../../../../assets/images/Verified_Check.svg";
import { useNavigate } from "react-router-dom";
import {
    convertLetterCase,
    formatDateToHumanReadable,
    getCountryByCode,
} from "../../../../utils/Helper";
import CommonTooltip from "../../../common/Tooltip";
import { useEffect } from "react";
import { FRONTEND_URL } from "../../../../constants/apiUrls";

export const EnterpriseCard = ({
    enterpriseData,
    page,
    setPage,
    searchById = true,
    enterpriseID = ""
}) => {
    const navigate = useNavigate();
    const claimedCompanies = enterpriseData?.results ?? [];

    const onRowClick = (id) => {
        const url = `${FRONTEND_URL}/search/${id}`;
        window.open(url, "_blank");
    };

    return (
        <>
            {claimedCompanies?.length > 0 ? (
                <div>
                    <div className="flex flex-wrap gap-3">
                        {claimedCompanies?.map((company, index) => (
                            <Card key={company.company + index} classes="max-w-sm w-full">
                                <div className="rounded-lg border border-input relative">

                                    {(company.claimed || company.verified) && <div className={`absolute top-0 right-0 z-[99999] flex items-center justify-center p-1 m-2 px-2 rounded-lg ${company.verified ? "bg-[#269758]" : "bg-claimed"}`}>
                                        <CommonTooltip styles={{ fontSize: "8px" }} id={'statusTooltip'} content={company.verified ? 'VERIFIED' : 'ACCESSED'}><div className="w-[20px] h-[20px]">
                                            <VerifiedCheck />
                                        </div></CommonTooltip>
                                    </div>}
                                    <div
                                        className={`p-2 text-white bg-company rounded-t-lg relative ${(searchById || company?.company_id || company?.worldbox_id) ? "cursor-pointer" : "cursor-not-allowed"}`}
                                        onClick={
                                            searchById
                                                ? () => navigate(`/dashboard/enterprise/${company?.id}`)
                                                : company?.company_id ? () => onRowClick(company?.company_id) : company?.worldbox_id ? () => onRowClick(company?.worldbox_id) : null
                                        }
                                    >
                                        <div className="flex flex-col items-center mt-10">
                                            <img
                                                src={company?.logo ? company?.logo : CompanyLogo}
                                                alt="company logo"
                                                className="w-20 h-20 rounded-full"
                                            />
                                            <h4 className="w-full mt-4 mb-2 text-lg font-semibold truncate">
                                                <CommonTooltip
                                                    styles={{ fontSize: "8px" }}
                                                    id={"company" + index}
                                                    content={
                                                        company.name?.toUpperCase() ||
                                                        company?.company_name?.toUpperCase()
                                                    }
                                                >
                                                    {company.name?.toUpperCase() ||
                                                        company?.company_name?.toUpperCase()}
                                                </CommonTooltip>
                                            </h4>
                                        </div>
                                    </div>
                                    <div class="px-4 py-2 bg-secondary rounded-b-lg">
                                        <div class="text-f14 flex flex-col text-left">
                                            {company?.registered_company_name && (
                                                <div class="text-left text-primary text-f16 font-black truncate mb-1">
                                                    <span>
                                                        {convertLetterCase(
                                                            company?.registered_company_name,
                                                            "uppercase"
                                                        )}
                                                    </span>
                                                </div>
                                            )}
                                            {(company?.country || company?.state) && (

                                                <div className="text-left text-primary font-bold text-xs truncate mb-1 text-f12 flex items-center justify-between h-full">
                                                    <p className="flex items-center h-full">
                                                        {company?.state && `${convertLetterCase(company?.state, "titlecase")}, `}
                                                        {getCountryByCode(company?.country) ?? company?.country}
                                                    </p>
                                                    <p className="flex items-center h-full">
                                                        {company?.status !== "COMPANY_FOUND" ? (
                                                            <div className="bg-sky-50 text-sky-900 uppercase p-1 px-2 rounded-full border-2">
                                                                {company?.status === "WORLDBOX_ORDER_CREATED" ?
                                                                    "Order In Progress" :
                                                                    // convertLetterCase(company?.status.split("_").join(" "), "titlecase")
                                                                    "Order In Progress"
                                                                }
                                                            </div>
                                                        ) : (
                                                            <div className="invisible bg-sky-50 text-sky-900 uppercase p-1 px-2 rounded-full border-2 border-transparent">
                                                                No Status
                                                            </div>
                                                        )}
                                                    </p>

                                                </div>
                                            )}
                                            {/* <div className="flex justify-between mb-1 text-[12px]">
                                                
                                            </div> */}
                                            {!searchById && <hr className="my-1" />}
                                            {Array.isArray(company?.updates) && (
                                                <div class="flex justify-between items-center text-left text-primary">
                                                    <div className="text-primary text-[12px]">
                                                        {company?.updates?.length > 0
                                                            ? company?.updates?.length
                                                            : "No" + " "}{"   "}
                                                        New Changes
                                                    </div>
                                                    {company?.updates?.length > 0 && (
                                                        <div onClick={() => {
                                                            navigate("/dashboard/enterprise/act-log", {
                                                                state: { company, page, enterpriseID },
                                                            })
                                                        }} className="cursor-pointer text-success font-bold">
                                                            View Activity
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        {searchById && <><hr />
                                            <div className="text-left text-[10px] mt-1">
                                                {company?.start_date && company?.end_date ? (
                                                    <p>
                                                        Subscription valid from{" "}
                                                        <span className="font-bold">
                                                            {formatDateToHumanReadable(
                                                                company.start_date,
                                                                "do MMMM yyyy"
                                                            )}
                                                        </span>{" "}
                                                        to{" "}
                                                        <span className="font-bold">
                                                            {formatDateToHumanReadable(
                                                                company.end_date,
                                                                "do MMMM yyyy"
                                                            )}
                                                        </span>
                                                    </p>
                                                ) : (
                                                    <p>Subscription is not activated yet</p>
                                                )}
                                            </div>
                                        </>}
                                    </div>
                                </div>
                            </Card>
                        ))}
                    </div>
                    {enterpriseData?.total_pages > 1 && <div className="flex justify-center items-center mt-3">
                        <div className="flex gap-2 items-center text-f16">
                            <div
                                className={`flex text-[#002940] gap-1 ${page === 1 ? "cursor-not-allowed" : "cursor-pointer"
                                    }`}
                                onClick={page > 1 ? () => setPage(page - 1) : null}
                            >
                                <ArrowRight className="rotate-180 mt-[1px]" /> Previous
                            </div>
                            <div>
                                Page {page} of {enterpriseData?.total_pages}
                            </div>
                            <div
                                className={`flex text-[#002940] gap-1 ${page === enterpriseData?.total_pages
                                    ? "cursor-not-allowed"
                                    : "cursor-pointer"
                                    }`}
                                onClick={
                                    page < enterpriseData?.total_pages
                                        ? () => setPage(page + 1)
                                        : null
                                }
                            >
                                Next <ArrowRight className="mt-[1px]" />
                            </div>
                        </div>
                    </div>}
                </div >
            ) : (
                <div className="text-primary font-bold text-[22px]">
                    No records to display
                </div>
            )}
        </>
    );
};
